<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-layout wrap pb-4>
      <v-flex xs12 py-3 text-left>
        <span style="font-family: opensansbold; font-size: 16px; color: black">
          Stocks</span
        >
      </v-flex>
      <v-flex xs6 sm3 pt-2 pt-sm-0 pl-sm-0>
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <router-link to='/Seller/StockView?stat=0'>
          <v-layout pa-2 pl-4 py-4 wrap justify-start>
            <v-flex xs12 class="mx-auto" pt-4>
              <v-img
                src="./../../../assets/orders.png"
                height="32px"
                contain
              ></v-img>
            </v-flex>
            <v-flex pt-1 xs12 center>
              <span
                style="
                  font-family: opensanssemibold;
                  font-size: 12px;
                  color: #6e6b6b;
                "
              >
                {{ storage.allProducts }} Products
              </span>
            </v-flex>
            <v-flex xs12 text-center align-self-center>
              <span
                style="font-family: opensansbold; font-size: 13px; color: green"
              >
                All Products
              </span>
            </v-flex>
          </v-layout>
          </router-link>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 pt-2 pt-sm-0 pl-sm-2>
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <router-link to='/Seller/StockView?stat=3'>
          <v-layout pa-2 pl-4 py-4 wrap justify-start>
            <v-flex xs12 class="mx-auto" pt-4>
              <v-img
                src="./../../../assets/orders.png"
                height="32px"
                contain
              ></v-img>
            </v-flex>
            <v-flex pt-1 xs12 center>
              <span
                style="
                  font-family: opensanssemibold;
                  font-size: 12px;
                  color: #6e6b6b;
                "
              >
                {{ storage.bestSellingProducts }} Products
              </span>
            </v-flex>
            <v-flex xs12 text-center align-self-center>
              <span
                style="
                  font-family: opensansbold;
                  font-size: 13px;
                  color: #f5bf42;
                "
              >
                Best Selling
              </span>
            </v-flex>
          </v-layout>
          </router-link>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 pt-2 pt-sm-0 pl-sm-2>
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <router-link to='/Seller/StockView?stat=2'>
          <v-layout pa-2 pl-4 py-4 wrap justify-start>
            <v-flex xs12 class="mx-auto" pt-4>
              <v-img
                src="./../../../assets/orders.png"
                height="32px"
                contain
              ></v-img>
            </v-flex>
            <v-flex pt-1 xs12 center>
              <span
                style="
                  font-family: opensanssemibold;
                  font-size: 12px;
                  color: #6e6b6b;
                "
              >
                {{ storage.limitedStockProducts }} Products
              </span>
            </v-flex>
            <v-flex xs12 text-center align-self-center>
              <span
                style="
                  font-family: opensansbold;
                  font-size: 13px;
                  color: #0b5f8a;
                "
              >
                Limited Stock
              </span>
            </v-flex>
          </v-layout>
          </router-link>
        </v-card>
      </v-flex>
      <v-flex xs6 sm3 pt-2 pt-sm-0 pl-sm-2>
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <router-link to='/Seller/StockView?stat=1'>
          <v-layout pa-2 pl-4 py-4 wrap justify-start>
            <v-flex xs12 class="mx-auto" pt-4>
              <v-img
                src="./../../../assets/orders.png"
                height="32px"
                contain
              ></v-img>
            </v-flex>
            <v-flex pt-1 xs12 center>
              <span
                style="
                  font-family: opensanssemibold;
                  font-size: 12px;
                  color: #6e6b6b;
                "
              >
                {{ storage.outofStockProducts }} Products
              </span>
            </v-flex>
            <v-flex xs12 text-center align-self-center>
              <span
                style="font-family: opensansbold; font-size: 13px; color: red"
              >
                Out of Stock
              </span>
            </v-flex>
          </v-layout>
          </router-link>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-layout wrap justify-center>
      <v-flex xs12 text-left py-2>
        <span
          style="font-family: opensansbold; font-size: 14px; color: #808080"
        >
          Top Selling Products
        </span>
      </v-flex>
      <v-flex xs12 py-2 v-for="(item, i) in products" :key="i">
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <v-layout px-4 wrap justify-center>
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs3 sm2 pa-2 align-self-center>
                  <v-img
                    :src="mediaURL + item.productId.photos[0]"
                    height="80px"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF4343"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex pt-4 xs9 sm10 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm6>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <router-link
                            :to="'/Seller/Product/' + item._id"
                          >
                            <span
                              style="
                                font-family: opensansbold;
                                font-size: 16px;
                                color: #808080;
                              "
                            >
                              {{ item.name.slice(0, 25) }}
                              <span v-if="item.name.length > 25">
                                ...
                              </span>
                            </span>
                          </router-link>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            Price: ₹{{ item.price }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Sale
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            ₹{{ item.productSubTotal }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Today
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            ₹{{ item.productSubTotal }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Item Sold
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            {{ item.quantity }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout> -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      products: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "seller/ordered/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productOrderStatus: "ordered",
          page: 1,
          limit: 3,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            // console.log("products",this.products)
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>